import { yup, yupResolver } from '@sahinyazilim/sahinyazilim-components';

export const PostFormYup = yupResolver<any>(
  yup
    .object({
      title: yup.string().min(6).required(),
      content: yup.string().min(5).required(),
    })
    .required(),
);
